import { range } from 'lodash-es';

export default {
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    url: {
      type: Function,
      required: true,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pages() {
      return range(1, this.totalPages + 1);
    },
  },
};
